<template>
  <div class="col-md-1 mainCountrySelectorContainer">
    <div class="region with-flyout country-select" data-flyout-content>
      <a
        id="authenticatedUserModalCountryLink-ship-to"
        @click.prevent="toggleDropDown('country-select')"
        href
        data-flyout="cbt-popUp"
        :title="getSelectedCountry.country_name"
        data-test="authenticatedUserModalCountryLink"
      >
        <i
          v-if="(getSelectedCountry && getSelectedCountry.country_flag)"
          data-test="authenticatedUserModalCountryI1"
          id="authenticatedUserModalCountryI1"
        >
          <img
            :src="getSelectedCountry.country_flag"
            style="width: 32px;"
            :alt="getSelectedCountry.country_name"
            id="authenticatedUserModalCountryImg-country-img"
            data-test="authenticatedUserModalCountryImg"
          />
        </i>
        <i
          class="ae"
          v-else
          id="authenticatedUserModalCountryI2-ae"
          data-test="authenticatedUserModalCountryI2"
        ></i>
      </a>
      <div style="display: none;" class="wp_countrySelectingContainer" id="country-select">
        <!--<ul id="cbt-popUp-one" class="option2">-->
        <!--<li>-->
        <!--<label>-->
        <!--<b id="country-label">Ship to </b>-->
        <!--</label>-->
        <country-picker />
        <!--</li>-->
        <!--</ul>-->
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { countrySelector } from '../../../commonJs/CountrySelector'
import CountryPicker from '../widgets/CountryPicker'

export default {
	mounted () {
		$(window)
			.on('load', () => {
				$('#countyselectleModal')
					.modal('hide')
			})
			// this.profilePic = this.getUserData.image_url;
	},
	data () {
		return {
			screenWidth: 0,
			selected: '',
			currencyValues: [],
			showCountry: {
				type: Boolean,
				default: true
			}
			// profilePic: '',
		}
	},
	computed: {
		...mapGetters('siteData', [
			'getSelectedCountry',
			'getCountriesWithShipping'
		]),
		...mapGetters('user', [
			'isAuthenticated',
			'getUserData',
			'getProfilePicture'
		]),
		...mapGetters('cart', ['getOrderCart']),
		...mapGetters('cart', ['getCartCount'])
	},
	methods: {
		...mapActions('siteData', [
			'setChosenCountryData',
			'setCountriesWithShipping'
		]),
		// toggleDropDownCountry() {
		//   if (this.selected && this.selected.country_code !== this.getSelectedCountry.country_code) {
		//     this.selected = JSON.parse(JSON.stringify(this.getSelectedCountry));
		//     this.$forceUpdate();
		//   }
		// },

		// changeCountriesStyleToggler() {
		//   $('#countyselectleModal')
		//     .modal('hide');
		//   $('body')
		//     .removeClass('modal-open');
		//   $('.modal-backdrop')
		//     .remove();
		// },
		// toggleDropDown(dropDownId) {
		//   eventService.toggleDropDown(dropDownId);
		// },
		saveChosenCountry (dropDownId = 'country-select', index = 0) {
			// this.selected = this.getCountriesWithShipping[index];
			// this.setChosenCountryData(this.selected);
			//
			// if (this.screenWidth > 991) {
			//   this.toggleDropDown(dropDownId);
			// } else {
			//   this.changeCountriesStyleToggler();
			//   this.toggleDropDown(dropDownId);
			// }
			countrySelector.saveChosenCountry(dropDownId, index)
			this.showCountry = false
		},
		toggleDropDown (dropDownId) {
			countrySelector.toggleDropDown(dropDownId)
			// this.$emit('toggleCountryDropDown', dropDownId);
		},
		togglesidebar () {
			// eslint-disable-next-line quotes
			document.querySelector('.mobile-side-nav')
				.classList
				.add('shown')
			$('body').addClass('stop-scroll')
			$('#mainApp').addClass('backdrop')
		}
	},
	components: {
		CountryPicker

	}
}
</script>
